import config from '../constants/config';

export const submitForm = (form: any) =>
  fetch(`${config.apiUrl}/api/v1/roofer`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(form),
  });
